import React from 'react';
import {TerritoriesContainer} from '../../Containers/TerritoryContainer';

const Territories = (props) => {
	return (
		<TerritoriesContainer />
	);
}

export default Territories;